import {BASE_HOST} from "./urlConst";
import axios from "./axios";

export function setCookie(name,value,days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = `; expires=${  date.toUTCString()}`;
    }
    document.cookie = `${name}=${  value || ""   }${expires  }; path=/`;
}
export function getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i+=1) {
        let c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp(`[?&]${  name  }(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getPricing(){
    return [
        {id: 0,"costPerEmail": 0.004, "price": 20},
        {id: 1,"costPerEmail": 0.003, "price": 30},
        {id: 2,"costPerEmail": 0.0024, "price": 60},
        {id: 3,"costPerEmail": 0.002, "price": 100},
        {id: 4,"costPerEmail": 0.0018, "price": 180},
        {id: 5,"costPerEmail": 0.0014, "price": 280},
        {id: 6,"costPerEmail": 0.0012, "price": 600},
        {id: 7,"costPerEmail": 0.001, "price": 1000},
        {id: 8,"costPerEmail": 0.0009, "price": 4500},
    ]
}

/**
 * List of objects with keys startDate and endDate
 * O(n^2)
 * @param ranges
 */
export function dateRangesOverlap(ranges){
    for(let x=0;x<ranges.length;x+=1){
        for(let y=x+1;y<ranges.length;y+=1){
            const v1 = ranges[x];
            const v2 = ranges[y];
            if(v1.startDate < v2.endDate && v2.startDate < v1.endDate){
                // They overlap (not just touch)
                return true;
            }

        }
    }
    return false;
}

export function swapStartAndEnd(obj){
    if (obj.startDate > obj.endDate){
        const tmp = obj.endDate;
        obj.endDate = obj.startDate;
        obj.startDate=tmp
    }
}

function findCommonElement(array1, array2) {

    // Loop for array1
    for (let i = 0; i < array1.length; i+=1) {

        // Loop for array2
        for (let j = 0; j < array2.length; j+=1) {

            // Compare the element of each and
            // every element from both of the
            // arrays
            if (array1[i] === array2[j]) {

                // Return if common element found
                return true;
            }
        }
    }

    // Return if no common element exist
    return false;
}

/**
 * List of objects with keys startDate and endDate.
 * Modifies date piece and sets to zero
 * O(n^2)
 * @param ranges
 */
export function hoursOfDayOverlap(ranges){

    for(let x=0;x<ranges.length;x+=1){
        for(let y=x+1;y<ranges.length;y+=1){
            const v1 = ranges[x];
            const v2 = ranges[y];

            swapStartAndEnd(v1);
            swapStartAndEnd(v2);

            v1.startDate.setFullYear(1,1,1,);
            v2.startDate.setFullYear(1,1,1,);
            v1.endDate.setFullYear(1,1,1,);
            v2.endDate.setFullYear(1,1,1,);

            if(v1.startDate < v2.endDate && v2.startDate < v1.endDate && findCommonElement(v1.days, v2.days)){
                // They overlap (not just touch)
                return true;
            }

        }
    }
    return false;
}



export function refreshAds(setter, startDate, endDate, parentId ,idToken) {
    if (idToken){
        let constUrl = `${BASE_HOST}/api/basic/ads?startDate=${startDate.toISOString().substring(0, 10)}&endDate=${endDate.toISOString().substring(0, 10)}`;
        if(parentId){
            constUrl+=`&parentId=${parentId}`
        }
            axios.get(constUrl, { headers: {
                            Authorization: `Bearer ${idToken}`
                        }})
            .then(res => {
                setter(res.data);
            })
    }else{
        console.log("No User")
    }
}
